import type { DomApplier } from '../cssFeatures.types'
import type { TimeAnimationOptions } from '@wix/thunderbolt-becky-types'
import { getVariantSelectors } from '../../utils/variantsUtils'

const MOTION_EFFECTS_ENTER_DONE_SELECTOR = ':not([data-motion-enter="done"])'

function getInitialFrame(item: TimeAnimationOptions | null): Record<string, any> {
	// TODO: implement for keyframeEffect
	// TODO: implement this properly - currently just following impl. of ScreenIn
	if (item?.namedEffect && (item.fill === 'backwards' || item.fill === 'both') && !item.reversed) {
		return { opacity: 0 }
	}

	return { opacity: 'var(--comp-opacity, 1)' }
}

function transformToFrameSelector(selectors: Array<string>) {
	return selectors.map((selector_) => `${selector_}${MOTION_EFFECTS_ENTER_DONE_SELECTOR}`).join(',')
}

function mergeFrames(frame1: Record<string, any>, frame2: Record<string, any>) {
	return {
		opacity: frame1.opacity === 0 || frame2.opacity === 0 ? 0 : frame2.opacity,
	}
}

export const motionEffectsDomApplier: DomApplier<'motionEffects'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ motionEffects },
	cssContext
) => {
	if (motionEffects) {
		// fetches initial frame from all effects per a given breakpointId
		return motionEffects
			.flatMap(({ data: breakpointToEffect, variants }) => {
				const { default: defaultBreakpoint, ...restOfBreakpoints } = breakpointToEffect

				const defaultFrameStyles = Object.entries(defaultBreakpoint).map(([variantKey, item]) => ({
					selectors: getVariantSelectors(variantKey, variants, compId, cssContext),
					frame: getInitialFrame(item),
				}))

				if (breakpointId === 'default') {
					return defaultFrameStyles
				}

				return restOfBreakpoints[breakpointId]
					? Object.entries(restOfBreakpoints[breakpointId]).map(([variantKey, item]) => {
						const variantSelectors = getVariantSelectors(variantKey, variants, compId, cssContext)
						// TODO: may need to also implement check if there's an equality between different selectors inside the variant's selector list
						return {
							selectors: variantSelectors,
							frame: getInitialFrame(item),
						}
					})
					: []
			})
			.reduce((styleRules, effectVariants) => {
				// transform all selector lists to a single selector string
				const selector = transformToFrameSelector(effectVariants.selectors)

				// merge frames per selector for all effects - so we get a single frame per selector
				if (styleRules[selector]) {
					styleRules[selector] = mergeFrames(styleRules[selector], effectVariants.frame)
				} else {
					styleRules[selector] = effectVariants.frame
				}

				return styleRules
			}, {} as Record<string, {}>)
	}

	return null
}
